import React, {
    useEffect,
    useState,
    useRef,
    useContext,
    useCallback,
    Fragment,
  } from "react";
  import ReactDOM from "react-dom";
  import { useLocation, useNavigate } from "react-router-dom";
  import sanityClient from "../../client.js";
  import "./contact.styles.scss";
  
  import { PortableText } from "@portabletext/react";
  import SanityMuxPlayer from "sanity-mux-player";
  import imageUrlBuilder from "@sanity/image-url";

  import ReactPlayer from 'react-player'

    import { MouseContext } from "../../context/mouse-context"

  const builder = imageUrlBuilder(sanityClient);
  
  function urlFor(source) {
    return builder.image(source);
  }
  
  const Contact = ({content}) => {
    const {cursorChangeHandler} = useContext(MouseContext);

    const customComponent = {      
        marks: {
          link: ({children, value}) => {
            if(value.href.includes('pdf')){
                return(
                    <a
                    onMouseEnter={() => cursorChangeHandler("active")}
                    onMouseLeave={() => cursorChangeHandler("")}
                    href={value.href} download>
                      {children}
                    </a>
                )
            }else{
            return (
              <a
              onMouseEnter={() => cursorChangeHandler("active")}
              onMouseLeave={() => cursorChangeHandler("")}
              href={value.href} target={'_blank'}>
                {children}
              </a>
            )
            }
          },
        },
      }

// console.log(content)
    if(!content) return<></>
    return (
      <div className={"contact-wrapper"}>
         <div className="section">
         <div className="section-title title-font">Contact</div>
            <PortableText
              value={content[0].about}
              components={customComponent}
            />
        </div>
      </div>
    );
  };
  
  export default Contact;
  